import httpBuildQuery from 'http-build-query';
import API from './api';

export default {
    getSuppliers() {
        return API.get('suppliers')
        .then((res) => {
            const result = res.data;
            return result;
        });
    },
    addSupplier(formdata) {
        return API.post('addsupplier', httpBuildQuery(formdata)).then(res => (res.data));
    },
    editSupplier(formdata) {
        return API.post('editsupplier', httpBuildQuery(formdata)).then(res => (res.data));
    },
    getInfo(id) {
        return API.get(`supplierinfo/id/${id}`).then(res => (res.data));
    },
    updateSupplierStatus(id, status) {
        return API.get(`updateSupplierStatus/id/${id}/status/${status}`).then((res) => {
            const result = res.data;
            return result;
        });
    },
};
